require("./best-segment.scss");


(function ($) {
    const $ctl = $("a[class^='summary-toggle-']");

    const toggle = (item) => {

        if (window.innerWidth <= 576) {
            if (item.hasClass('collapsed-text')) {
                item.removeClass('collapsed-text').addClass('expanded-text');
                return true;
            } else {
                item.removeClass('expanded-text').addClass('collapsed-text');
                return false;
            }
        }
    };

    $(function () {
        $ctl.on('click',
            function (e) {
                e.preventDefault();
                toggle($(this).parent());
            });
    });
})(jQuery);